import React, { useState } from 'react';
import { GRID_SIZE } from '../constants/config';
import { scoreToDotColor, scoreToCellBackground } from '../utils/scoreColors';
import DefinitionPopover from './DefinitionPopover';

function DefIcon({ adj, definition, activeDefinition, setActiveDefinition }) {
  if (!definition) return null;
  const isActive = activeDefinition === adj;
  return (
    <span className="relative inline-block ml-0.5 align-middle">
      <button
        onClick={(e) => { e.stopPropagation(); setActiveDefinition(isActive ? null : adj); }}
        className="text-ink-light hover:text-ink leading-none"
        style={{ fontSize: '8px' }}
        aria-label={`Definition of ${adj}`}
      >
        {'\u24D8'}
      </button>
      {isActive && (
        <DefinitionPopover
          word={adj}
          definition={definition}
          onClose={() => setActiveDefinition(null)}
          position="below"
        />
      )}
    </span>
  );
}

export default function MiniGrid({ cells, puzzle, hideWords, definitions }) {
  const [activeDefinition, setActiveDefinition] = useState(null);

  if (!cells || cells.length === 0) return null;
  return (
    <div className="grid gap-1" style={{ gridTemplateColumns: `3rem repeat(${GRID_SIZE}, 1fr)` }}>
      <div />
      {puzzle.colAdjectives.map((adj, i) => (
        <div key={i} className="text-center text-[10px] font-serif font-bold text-ink-light overflow-visible">
          <span className="truncate block">{adj}</span>
          <DefIcon adj={adj} definition={definitions?.[adj]} activeDefinition={activeDefinition} setActiveDefinition={setActiveDefinition} />
        </div>
      ))}
      {Array.from({ length: GRID_SIZE }).map((_, rowIdx) => (
        <React.Fragment key={rowIdx}>
          <div className="flex items-center justify-center text-[10px] font-serif font-bold text-ink-light">
            <span>
              {puzzle.rowAdjectives[rowIdx]}
              <DefIcon adj={puzzle.rowAdjectives[rowIdx]} definition={definitions?.[puzzle.rowAdjectives[rowIdx]]} activeDefinition={activeDefinition} setActiveDefinition={setActiveDefinition} />
            </span>
          </div>
          {Array.from({ length: GRID_SIZE }).map((_, colIdx) => {
            const cell = cells[rowIdx * GRID_SIZE + colIdx];
            if (!cell) return <div key={colIdx} className="p-1 border border-ink-faint" />;
            return (
              <div
                key={colIdx}
                className="p-1 text-center border border-ink-faint"
                style={{ backgroundColor: scoreToCellBackground(cell.score) }}
              >
                {!hideWords && (
                  <p className="text-[10px] font-body font-bold truncate text-ink">{cell.word}</p>
                )}
                {!hideWords &&
                  typeof cell.adj1Score === 'number' &&
                  typeof cell.adj2Score === 'number' && (
                    <div className="flex items-center justify-center gap-1 my-0.5">
                      <span
                        className="inline-block w-1.5 h-1.5 rounded-full"
                        style={{ backgroundColor: scoreToDotColor(cell.adj1Score) }}
                      />
                      <span
                        className="inline-block w-1.5 h-1.5 rounded-full"
                        style={{ backgroundColor: scoreToDotColor(cell.adj2Score) }}
                      />
                    </div>
                  )}
                <p
                  className={`font-body text-white inline-block px-1 rounded-full ${hideWords ? 'text-[10px]' : 'text-[8px]'}`}
                  style={{ backgroundColor: scoreToDotColor(cell.score) }}
                >
                  {cell.score.toFixed(1)}
                </p>
              </div>
            );
          })}
        </React.Fragment>
      ))}
    </div>
  );
}
